<template>
	<div class="chatlist">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- @click="back" -->
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">消息</p>
				</div>
			</div>
		</van-sticky>
		<!-- 系统消息 -->
		<div class="system_message" @click="go_system()">
			<img src="../../assets/img/new1.png" alt="">
			<span class="num" v-if="numMassage != 0">{{numMassage}}</span>
			<span>系统消息</span>
			<span style="text-align: right;display: block;width: calc(100vw - 130px);overflow: hidden;height:20px;margin-left:10px;" v-html="newest_msg"></span>
		</div>
		<!-- 消息列表 -->
		<div class="message_list">
			<ul class="list_part">
				<li v-for="item in personList" @click="go_msgdetail(item.admin_id)">
					<ol class="ol_img">
						<img :src="$api.$BASE_URL_img+item.admin_avatar" alt="">
					</ol>
					<ol class="ol_text">
						<p class="name">{{item.admin_name}}</p>
						<p class="info">{{item.content}}</p>
					</ol>
					<ol class="ol_right">
						<p class="time">{{item.createtime}}</p>
						<p class="num" v-if="item.not_read != 0">{{item.not_read}}</p>
					</ol>
				</li>
			</ul>
		</div>
		<!-- 发送消息 -->
		<div class="send_message" @click="go_chat()">
			<div class="bot_send">
				<div class="send_view">
					<span>输入消息内容</span>
					<img src="../../assets/img/new2.png" alt="">
				</div>
				<div class="btn">
					<button>发送</button>
				</div>
			</div>
		</div>
		<!-- 选择指定管理员 -->
		<div class="zd_admin" v-show="isAdmin" @click="hide_admin()">
			<div class="admin_view" @click.stop>
				<p class="admin_title">请指定管理员</p>
				<ul>
					<li 
						v-for="(item,index) in adminList" 
						:class="cc_id == index ? 'admin_active' : ''"
						@click="choose_admin(index,item.id)"
					>{{item.nickname}}</li>
				</ul>
				<div class="sure_btn">
					<button @click="sure_choose()">确定</button>
				</div>
			</div>
		</div>
		
		<!-- loading -->
		<Loading v-show="isLoading"></Loading>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				personList: [], //个人消息
				adminList:[], //管理员名单列表
				isAdmin: false, //管理员列表弹框
				cc_id: -1, //选择管理员index
				choose_id: '',
				isLoading: false, //loading显示
				numMassage: 0,
				newest_msg: '',
			}
		},
		mounted() {
			
		},
		created(){
			this.person_news(); //获取个人消息
			this.get_admin(); //获取管理员列表
			this.numMassage = this.$route.query.numMassage;//数量
			this.newest_msg = this.$route.query.newest_msg;
		},
		methods: {
			back (){
				this.$router.push('/userinfo')
			},
			go_chat() {
				this.isAdmin = true;
			},
			hide_admin() {
				this.isAdmin = false;
				this.cc_id = -1;
			},
			sure_choose() { //确定选择（创建新消息）
				var adminId = this.choose_id;
				if(!adminId){
					this.$toast('请指定管理员');
				}else{
					this.$router.push({ path: './sendmessage', query: { adminId: adminId ,newest_msg: this.$route.query.newest_msg,numMassage: this.$route.query.numMassage}});
				}
				
			},
			go_msgdetail(e) { //获取历史消息详情
				this.$router.push({ path: './sendmessage', query: { adminId: e }});
			},
			person_news() { //获取个人消息列表
				var _t = this;
				_t.isLoading = true;
				_t.$axios.post(`${_t.$api.get_user_msg}`).then((response) => {
					if(response.data.code == 1){
						var resdata = response.data.data;
						for(var i = 0; i < resdata.length; i++){
							resdata[i].createtime = _t.formatDateTime(resdata[i].createtime);
							resdata[i].content = resdata[i].content.replace(/<[^>]+>/g, "");
						}
						_t.personList = resdata;
					}else{
						_t.$toast(response.data.msg);
					}
					_t.isLoading = false;
				}).catch(() => {console.log('promise catch err');_t.isLoading = false;});
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2);
			
				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			go_system() {
				this.$router.push('/systemnews');
			},
			get_admin() { //获取管理员列表
				var _t = this;
				_t.$axios.post(`${_t.$api.receiver_list}`).then((response) => {
					if(response.data.code == 1){
						var resdata = response.data.data;
						_t.adminList = resdata;
					}else{
						_t.$toast(response.data.msg);
					}
					
				}).catch(() => console.log('promise catch err'));
			},
			choose_admin(index,id){
				var _t = this;
				_t.cc_id = index;
				_t.choose_id = id;
			}
		}
	}
</script>

<style scoped>
	/* 头部 */
	.headerBox {
		height: 160px;
		/* background-color: #ff4081; */
        /* background-image: linear-gradient(#ff6ea0, #ff4081); */
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;
	}
	.headerQuery {
		margin-top: 80px;
		padding: 0 16px;
		position: relative;
		display: flex;
		width: 100%;
		height: 80px;
		line-height: 80px;
		color: #000;
	}
	.arrImg	img {
		width: 40px;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0px;
	}
	.header_titile {
		flex: 1;
		text-align: center;
		font-size: 34px;
		/*px*/
	}
	/* 系统消息 */
	.system_message{
		background: #fff;
		padding:25px 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;
		
	}
	.system_message .num {
		position: absolute;
		bottom: 20px;
		left: 55px;
		background-color: #ff0000;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		text-align: center;
		line-height: 40px;
		color: #fff;
	}
	.system_message img{
		width:65px;
		height:65px;
		margin-right: 15px;
	}
	.system_message span{
		font-size: 28px;
	}
	/* 消息列表 */
	.message_list{
		background: #fff;
		border-top:15px solid #f9f9f9;
		padding:0px 20px 110px 20px;
		box-sizing: border-box;
	}
	.list_part li{
		border-bottom: 1px solid #dbdbdb;
		width:100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding:20px 0;
	}
	.list_part li .ol_img{
		width:11%;
	}
	.list_part li .ol_img img{
		width:65px;
		height:65px;
		border-radius: 50%;
	}
	.list_part li .ol_text{
		padding-top:6px;
		width:72%;
	}
	.list_part li .ol_text .name{
		font-size: 28px;
	}
	.list_part li .ol_text .info{
		font-size: 20px;
		color: #a3a3a3;
		margin-top:15px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.list_part li .ol_right{
		width:15%;
		text-align: right;
	}
	.list_part li .ol_right .time{
		font-size: 22px;
		color: #a4a4a4;
	}
	.list_part li .ol_right .num{
		display: inline-block;
		min-width:36px;
		min-height:36px;
		color: #fff;
		font-size: 18px;
		background: #FF0000;
		border-radius: 50%;
		text-align: center;
		line-height: 37px;
		margin-top:20px;
	}
	/* 底部发送消息部分 */
	.send_message{
		position: fixed;
		bottom: 0;
		left:0;
		width:100%;
		border-top:15px solid #f9f9f9;
		background: #fff;
		padding:10px 20px;
		box-sizing: border-box;
	}
	.bot_send{
		width:100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.bot_send .send_view{
		width:84%;
		height:65px;
		border:1px solid #FA7298;/*no*/
		border-radius: 65px;
		position: relative;
	}
	.send_view span{
		position: absolute;
		top:18px;
		left:20px;
		font-size: 22px;
		color: #A3A3A3;
	}
	.send_view img{
		position: absolute;
		right:20px;
		top:10px;
		width:46px;
		height:46px;
	}
	.bot_send .btn{
		width:16%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	.bot_send .btn button{
		width:82%;
		height:55px;
		border-radius: 10px;
		font-size: 26px;
		color: #fff;
		background: #FA7298;
		border:0;
	}
	/* 选择指定管理员 */
	.zd_admin{
		position: fixed;
		top:0;
		left:0;
		width:100%;
		height:100%;
		background: rgba(0,0,0,0.3);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.admin_view{
		background: #fff;
		width:80%;
		border-radius: 8px;
		padding:20px 20px;
	}
	.admin_view .admin_title{
		padding-bottom: 30px;
		font-size: 30px;
		text-align: center;
	}
	.admin_view ul{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		height:51vh;
		overflow-y: scroll;
	}
	.admin_view ul li{
		width:46%;
		height:70px;
		line-height: 70px;
		font-size: 26px;
		text-align: center;
		border-radius: 40px;
		margin-bottom: 20px;
	}
	.admin_view ul li:nth-child(4n-3){
		background: #FAF3F5;
		border:1px solid #FA7298;
	}
	.admin_view ul li:nth-child(4n-2){
		background: #E1EFF9;
		border:1px solid #81C5F7;
	}
	.admin_view ul li:nth-child(4n-1){
		background: #CFF0F4;
		border:1px solid #25CEDE;
	}
	.admin_view ul li:nth-child(4n){
		background: #fff8ef;
		border:1px solid #F4D372;
	}
	.admin_active{
		background: #ff4081 !important;
		border:1px solid #ff4081 !important;
		color: #fff;
	}
	.sure_btn{
		width:100%;
		padding:20px 20px 0;
		box-sizing: border-box;
		display: flex;
		justify-content: flex-end;
	}
	.sure_btn button{
		width:25%;
		font-size: 26px;
		color: #fff;
		border-radius: 6px;
		background: #ff4081;
		border:0;
		height:65px;
	}
</style>
